<style lang="less" scoped>
	/deep/ .el-radio-group {
		display: flex;

		label {
			border: none !important;
		}
	}

	.ridio {
		margin-left: 1rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;

		.el-radio {
			margin: 0.4rem 0;
		}


		label {
			width: auto !important;
			border-top: none !important;
			border-bottom: none !important;
			margin-left: 1rem !important;
		}

		label:first-child {
			margin-left: 0 !important;
		}



		/deep/ .el-radio__input.is-checked .el-radio__inner {
			border-color: #E2E5EA;
			background: #E2E5EA;
		}

		/deep/ .el-radio__inner::after {
			width: 8px;
			height: 8px;
			background-color: #3F7ECA;
		}
	}

	div {
		color: #333;
	}

	/deep/ .el-tag {
		background-color: #1CAF9A !important;
		color: #fff;
	}

	/deep/ .el-tag .el-tag__close {
		color: #fff;
	}


	.addinput {
		background: #fff;
		padding: 1rem;

		.addinputtop {
			width: 100%;
			height: 4rem;
			background: #fff;
			border-left: 4px solid #FFC107;
			padding: 0.7rem 0 0 1rem;
			margin-bottom: 1rem;
			box-sizing: border-box;

			p:first-child {
				font-size: 1.2rem;
				color: #333;

			}

			p:last-child {
				font-size: 0.8rem;
				color: #77818e;

			}
		}

		.addform {
			display: flex;
			justify-content: center;
			flex-direction: column;

			label:last-child {
				border-bottom: 1px solid #ccc;
			}

			label,
			.labelas {
				textarea {
					color: #333;
				}

				display: block;
				width: 100%;
				padding: 1rem 0;
				border-top: 1px solid #ccc;
				box-sizing: border-box;

				.labelchiles {
					margin: 0 auto;
					display: flex;
					align-items: center;

					p {
						width: 6rem;
						text-align: right;
						margin-right: 1rem;
						color: rgb(74, 83, 94);
						font-size: 0.8rem;
					}
				}
			}

		}

		.fromsbtn {
			// width: 50%;
			margin: 1rem auto;
			display: flex;
			align-items: center;
			justify-content: center;

			button {
				margin: 0 1rem;
				padding: 0.6rem 2rem;
				border-radius: 2px;
				background-color: #F7F7F7;
				color: #333;
				border: 1px solid #ccc;
			}

			button:first-child {
				background-color: #3071A9;
				color: #fff;
			}

			button:hover {
				background-color: #1f92ea;
			}

			button:last-child:hover {
				background-color: #d9d9d9;
			}


		}

	}


	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
</style>


<template>
	<div>
		<titles titlename="新增实训设备" titlecontent="添加实训设备" :mbx="paths"></titles>
		<div class="addinput">
			<div class="addinputtop">
				<p>设备基本信息</p>
				<p>请填写设备详细信息，以及设备功能描述</p>
			</div>
			<form class="addform">
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备名称<span style="color: red;">*</span></p>
						<input maxlength="20" v-model="trainsbobjs.te_deviceName" type="text" class="form-control"
							placeholder="请输入设备名称">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备编号<span style="color: red;">*</span></p>
						<input maxlength="20" v-model="trainsbobjs.te_deviceNumber" type="text" class="form-control"
							placeholder="请输入设备编号">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">所属院校<span style="color: red;">*</span></p>
						<select @change="chosedDtrain" v-model="trainsbobjs.si_guid" class="form-control"
							id="exampleFormControlSelect1">
							<option value=""> -- 请选择所属院校 --</option>
							<option v-for="(item,index) in schoollist" :key="index" :label="item.si_name_cn"
								:value="item.si_guid">
								{{item.si_name_cn}}
							</option>
						</select>
					</div>
				</label>

				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">所属实训室<span style="color: red;">*</span></p>
						<select v-model="trainsbobjs.sx_tr_guid" class="form-control" id="exampleFormControlSelect1"
							placeholder="请选择实训室" @change="chosedDtrain">
							<option value="">-- 请选择实训室 --</option>
							<option v-for="(item,index) in trainlist" :key="index" :value="item.sx_tr_guid">
								{{item.tr_name}}
							</option>
						</select>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">责任人</p>
						<input maxlength="20" v-model="trainsbobjs.te_maintenancer" type="text" class="form-control"
							placeholder="请输入负责人">
					</div>
				</label>
				<!-- <label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">状态</p>
						<div class="ridio">
							<el-radio-group v-model="radio">
								<el-radio label="1">
									正常（启用）
								</el-radio>
								<el-radio label="0">
									离线
								</el-radio>
								<el-radio label="-1">
									维护/检修
								</el-radio>
								<el-radio label="-2">
									空闲
								</el-radio>
							</el-radio-group>
						</div>
					</div>
				</label> -->


				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备图片</p>
						<upload :filelist="filelists"></upload>
					</div>
				</div>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备MAC地址</p>
						<input @input="macchanges()" maxlength="20" v-model="trainsbobjs.te_deviceMac" type="text"
							class="form-control" placeholder="请输入设备MAC地址"
							:style="{'border-color':ismacshow?'red':'','box-shadow': ismacshow?'1px 1px 1px red':''}">
						<span v-if="ismacshow" style="color: red;margin-left: 0.4rem;font-size: 0.6vw;">
							请输入正确的mac地址
						</span>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备ip地址</p>
						<input @input="ipchanges()" v-model="trainsbobjs.te_deviceIp" type="text" class="form-control"
							placeholder="请输入设备id地址"
							:style="{'border-color':isipshow?'red':'','box-shadow': isipshow?'1px 1px 1px red':''}">
						<span maxlength="20" v-if="isipshow" style="color: red;margin-left: 0.4rem;font-size: 0.6vw;">
							请输入正确的ip地址
						</span>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">备注</p>
						<input maxlength="20" v-model="trainsbobjs.te_deviceRemark" type="text" class="form-control"
							placeholder="请输入备注">
					</div>
				</label>
				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">Tag</p>
						<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
							@close="handleClose(tag)">
							{{tag}}
						</el-tag>
						<div style="width: 10vw;">
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
								size="small" @blur="handleInputConfirm" @keyup.enter.native="handleInputConfirm">
							</el-input>
							<button v-else size="small" class="button-new-tag" @click="showInput">新增</button>
						</div>
					</div>
				</div>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备功能描述</p>
						<textarea v-model="trainsbobjs.te_deviceIntroduction" class="form-control" rows="10"></textarea>
					</div>
				</label>
				<!-- <label style="border-bottom: 0 !important;">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2" style="width: auto;margin-left: 6rem;">
							<input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="ispassds">
							<span style="margin-left: 10px;">是否开启预约自动审核</span>
						</p>
					</div>
				</label> -->
			</form>
			<div class="fromsbtn col-xs-12 col-sm-10 col-md-8 col-lg-8">
				<button @click="savetrains()" v-preventReClick>提交</button>
				<button>取消</button>
			</div>
		</div>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import upload from "@/components/upload/uploadsb.vue"
	import {
		GetTrainInsert,
		GetbfyTrainEquipmentLists,
		getbfyGetTrainList
	} from "@/request/api/trainroom/trainroom.js"
	import {

		GetbjGetSchoolList,
	} from "@/request/api/mange/mange.js"
	
	import AppOptions from '@/config/AppOptions.vue';

	export default {
		data() {
			return {
				ispassds: false,
				ismacshow: false,
				isipshow: false,
				// 院校不分页
				schoollist: [],
				radio: "1",
				// 标题组件
				paths: [{
						path: "/device/trainingmangesb",
						name: "实训管理"
					},
					{
						path: "/device/addmangesb",
						name: "添加实训设备"
					}
				],
				// tag组件
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				// 添加实训设备
				trainsbobjs: {
					sx_tr_guid: "",
					si_guid: "",
					te_deviceNumber: "",
					te_deviceName: "",
					te_maintenancer: "",
					te_deviceMac: "",
					te_deviceIp: "",
					te_deviceIntroduction: "",
					te_deviceRemark: "",
					tr_maintenancerid:""
				},
				// 实训室不分页
				trainlist: [],
				filelists: []
			}
		},
		created() {
			AppOptions.appEmpty = false;
		},
		beforeMount() {
			// let ifs = localStorage.getItem("siguid")


			GetbjGetSchoolList().then(res => {
				// console.log(res, "院校不分页")
				this.schoollist = res.data.data
			})

		},
		updated() {

		},
		methods: {
			macchanges() {
				var reg_name = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/
				var reg_name1 = /[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}/
				if (reg_name.test(this.trainsbobjs.te_deviceMac) || reg_name1.test(this.trainsbobjs.te_deviceMac)) {
					this.ismacshow = false
				} else {
					this.ismacshow = true
				}

			},
			ipchanges() {
				var reg_name = /^((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))$/
				if (!reg_name.test(this.trainsbobjs.te_deviceIp)) {
					this.isipshow = true
				} else {
					this.isipshow = false
				}


			},


			// 获取实训室
			getmanges(ifs) {
				getbfyGetTrainList(ifs).then(res => {
					// console.log(res, "实训室不分页")
					this.trainlist = res.data.data
				})
			},

			// 更改实训室
			chosedDtrain() {
				this.getmanges(this.trainsbobjs.si_guid)
				let tarinobj = {}
				this.trainlist.forEach(item => {
					if (item.sx_tr_guid == this.trainsbobjs.sx_tr_guid) {
						tarinobj = item
						this.trainsbobjs.te_maintenancer = tarinobj.tr_maintenancer
						this.trainsbobjs.tr_maintenancerid = tarinobj.tr_maintenancerid
					}
				})
				// console.log(this.trainsbobjs, '获取obj')

				// this.trainsbobjs.sx_tr_guid = ""


			},
			// 设备保存
			savetrains() {


				var taglist = this.dynamicTags.join("#")
				var roomstrain = {
					te_deviceNumber: this.trainsbobjs.te_deviceNumber ?? '',
					te_deviceName: this.trainsbobjs.te_deviceName ?? '',
					te_maintenancer: this.trainsbobjs.te_maintenancer ?? '',
					te_deviceMac: this.trainsbobjs.te_deviceMac ?? '',
					te_tag: taglist,
					te_deviceIp: this.trainsbobjs.te_deviceIp ?? '',
					te_deviceIntroduction: this.trainsbobjs.te_deviceIntroduction ?? '',
					sx_tr_guid: this.trainsbobjs.sx_tr_guid ?? '',
					te_deviceRemark: this.trainsbobjs.te_deviceRemark ?? '',
					te_AutoApprove: this.ispassds ? 1 : 0,
					te_maintenancerid:this.trainsbobjs.te_maintenancerid ?? ""
				}
				
				
				
				// console.log(roomstrain)
				let from_data = new FormData()
				from_data.append("te_deviceNumber", roomstrain.te_deviceNumber ?? '')
				from_data.append("te_deviceName", roomstrain.te_deviceName ?? '')
				from_data.append("te_maintenancer", roomstrain.te_maintenancer ?? '')
				from_data.append("te_deviceMac", roomstrain.te_deviceMac == "undefined" ? "" : roomstrain.te_deviceMac)
				from_data.append("te_tag", taglist)
				from_data.append("te_deviceIp", roomstrain.te_deviceIp == "undefined" ? "" : roomstrain.te_deviceIp)
				from_data.append("te_deviceIntroduction", roomstrain.te_deviceIntroduction == "undefined" ? "" : roomstrain
					.te_deviceIntroduction)
				from_data.append("sx_tr_guid", roomstrain.sx_tr_guid == "undefined" ? "" : roomstrain.sx_tr_guid)
				from_data.append("te_deviceRemark", roomstrain.te_deviceRemark == "undefined" ? "" : roomstrain
					.te_deviceRemark)
				from_data.append("filename", this.$store.state.trainimg == "undefined" ? "" : this.$store.state.trainimg)
				// from_data.append("te_AutoApprove", roomstrain.te_AutoApprove)
				from_data.append("te_maintenancerid", roomstrain.te_maintenancerid)
				/* else if(this.ismacshow || this.trainsbobjs.te_deviceMac == ''){
					this.$message("mac地址错误且不能为空")
				} else if(this.isipshow || this.trainsbobjs.te_deviceMac == ''){
					this.$message("mac地址错误且不能为空")
				} */



				if (this.trainsbobjs.te_deviceNumber == "") {
					this.$message("设备编号不能为空")
				} else if (this.trainsbobjs.te_deviceName == "") {
					this.$message("设备名称不能为空")
				} else if (this.trainsbobjs.si_guid == "") {
					this.$message("院校不能为空")
				} else if (this.trainsbobjs.sx_tr_guid == "") {
					this.$message("实训室不能为空")
				} else {
					GetTrainInsert(from_data).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.trainsbobjs = {}
							this.$store.state.trainimg = ""
							this.dynamicTags = []
							this.filelists = []
							this.trainsbobjs.sx_tr_guid = ""
							this.trainsbobjs.si_guid = ""
						} else {
							this.$message(res.data.msg);
						}
					})
				}

			},


			// 标签
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(() => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			opentag() {
				// console.log(111)
			},
			deletag(i) {
				// console.log(i)
				this.tags.splice(i, 1)
			}
		},
		components: {
			titles,
			upload
		}
	}
</script>

<style>
</style>